import React, {Component} from 'react';
import axios from "axios";

class MiniDocumentViewer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            src : props.src ? props.src : "",
            isExist: false,
            filename: "",
            isLoading: true,
        }
    }

    fetchFile = async () => {
        try {
            let token = localStorage.getItem('login_token');
            let headers = {"Content-Type": "application/json"};
            headers["Authorization"] = `Bearer ${token}`

            const res = await axios.post(
                `${process.env.API_URL}/dbq/get-exam-mini`,
                {
                    disabilityId: this.state.src,
                },
                { headers }
                );

            const fileName = res.data.filename.replace("/minifile/", "")
            
            const response = await fetch(`${process.env.API_URL}/file/${fileName}`, {
                method: 'GET',
                headers,
            });
        
            if (!response.ok) throw new Error("Failed to fetch PDF");
        
            const blob = await response.blob();
            const fileUrl = URL.createObjectURL(blob);
            
            this.setState({ filename: fileUrl, isExist: true })
        
        } catch (error) {
            this.setState({ isExist: false })
            console.error("PDF Fetch Error:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    componentDidMount() {
        this.fetchFile();
    }

    componentWillUnmount() {
        if (this.state.filename) {
            URL.revokeObjectURL(this.state.filename);
        }
    }

    render() {
        const {
            onClose
          } = this.props
          
        return (
            <div className="overlay-msg" onClick={e => {onClose(e)}}>                
                <div className="overlay-box">
                    <div className="row">
                        {
                            this.state.isLoading ? (
                                <div style={{ color: "#F12F39" }}>
                                    <h1>Loading file ...</h1>
                                </div>
                            ) :
                            this.state.isExist? <iframe title="mini iframe"  width="100%" height="700" src={this.state.filename}></iframe > :
                            <div style={{color: "#F12F39"}}>
                                <h1>
                                    Mini document is not available
                                </h1>
                            </div>
                        }                        
                    </div>                    
                </div>
            </div>           
        );
    }
}

export default MiniDocumentViewer